import { useCallback } from 'react';
import { bridge } from '../utils';
import { useAnalyticsContext } from '../context/AnalyticsContext';
import type { LogAnalyticsEventParams } from '../utils/bridge/logAnalyticsEvent/types';

export const useLogAnalyticsEvent = () => {
  const { screen, defaultAnalytics, defaultAblyOnlyLog } =
    useAnalyticsContext();

  return useCallback(
    (params: LogAnalyticsEventParams) => {
      bridge.logAnalyticsEvent({
        ...params,
        analytics: {
          ...(screen != null && { SCREEN: screen }),
          ...defaultAnalytics,
          ...params.analytics,
        },
        ably_only_log: {
          ...defaultAblyOnlyLog,
          ...params.ably_only_log,
        },
      });
    },
    [screen, defaultAnalytics, defaultAblyOnlyLog],
  );
};
